var _path, _circle, _circle2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6159 9.55826L19.1213 9.72407C19.174 9.74136 19.2246 9.7623 19.2727 9.78654L20.5137 10.4122C20.8454 10.5795 21 10.8669 21 11.1257V14.1667C21 14.5468 20.636 15 20 15H4C3.36403 15 3 14.5468 3 14.1667V11.0572C3 10.73 3.25888 10.3496 3.76796 10.2469L6.53081 9.68975C6.53082 9.68975 6.53082 9.68975 6.53082 9.68975C6.54405 9.68708 6.55735 9.68464 6.57071 9.68243L7.19655 9.57881L7.36949 8.96848L8.02784 6.64506C8.12124 6.31543 8.48566 6 9.00148 6H16.8168C17.3326 6 17.6971 6.31543 17.7905 6.64506L18.4709 9.04654L18.6159 9.55826Z",
    fill: "white",
    stroke: "#222F7D",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 2,
    fill: "white",
    stroke: "#222F7D",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15,
    r: 2,
    fill: "white",
    stroke: "#222F7D",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.31ff6a91.svg";
export { ForwardRef as ReactComponent };